module.exports = __webpack_public_path__ + "static/customer-notification@2x-64c072232bdc4f3088c8903eba5fdc6c.png";